import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
export default {
  name: 'CoreVirtualDeviceDialogCreateView',
  mixins: [multiSearchMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedAccount: null,
      viewTitle: '',
      viewDescription: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    saveDisabled: function saveDisabled() {
      // https://digimondo.atlassian.net/browse/RD-6971
      // only requires account and title, search-items are optional - to create view of all devices of an account
      return !this.selectedAccount || !this.viewTitle;
    },
    filteredSearchTypes: function filteredSearchTypes() {
      return this.searchTypes.filter(function (type) {
        return type.param !== 'health' && type.param !== 'zone';
      });
    }
  }),
  watch: {
    loadingDataDone: {
      handler: function handler(loadingDone) {
        if (loadingDone) {
          this.initEditItem();
        }
      },
      immediate: true
    },
    isOpen: function isOpen(val) {
      if (val) {
        this.open();
      }
    }
  },
  methods: {
    initEditItem: function initEditItem() {
      var _this = this;

      this.viewTitle = this.editItem.title || '';
      this.viewDescription = this.editItem.description || '';
      this.selectedAccount = this.editItem.tenantId || null;
      var search = ((this.editItem || {}).viewConfig || {}).searchItems || [];
      var t = search.map(function (item) {
        if (item.variable === 'deviceType') {
          var devices = _this.searchTypes.find(function (type) {
            return type.param === 'deviceType';
          }).items;

          return {
            param: item.variable,
            search: {
              value: item.search,
              text: devices.find(function (device) {
                return device.value === item.search;
              }).text
            }
          };
        }

        if (item.variable === 'operationalStatus') {
          return {
            param: item.variable,
            search: {
              value: item.search,
              text: _this.operationalStatus[item.search]
            }
          };
        }

        return {
          param: item.variable,
          search: item.search
        };
      });
      this.searchItems = t;
      this.searchOperator = (this.editItem.viewConfig || {}).searchOperator;
    },
    searchUpdated: function searchUpdated(searchItems, operator) {
      this.searchItems = searchItems; // defined in multiSearchMixin

      this.searchOperator = operator; // defined in multiSearchMixin
    },
    open: function open() {
      // should this be called every time the dialog opens?
      this.getMultiFilterData(); // defined in multiSearchMixin
    },
    close: function close() {
      // reset values on dialog close
      this.selectedAccount = null;
      this.viewTitle = '';
      this.viewDescription = '';
      this.searchItems = []; // defined in multiSearchMixin

      this.$emit('close');
    },
    createRequestOptions: function createRequestOptions() {
      return {
        tenantId: this.selectedAccount,
        title: this.viewTitle,
        description: this.viewDescription,
        // meta: null, // meta is included in the docs, but API throws 400 when used
        viewConfig: {
          searchItems: this.searchItems.map(function (item) {
            return {
              variable: item.param,
              // support item.search.value === null, so do not simply have a >search.value || search< expression
              search: (item.search || {}).value === undefined ? item.search : item.search.value
            };
          }),
          searchOperator: this.searchOperator,
          filters: [{
            type: 'tenantIds',
            ids: [this.selectedAccount]
          }],
          options: null
        },
        meta: {}
      };
    },
    update: function update() {
      var params = this.createRequestOptions();
      params.id = this.editItem.id;
      this.$emit('update', params);
      this.close();
    },
    save: function save() {
      var params = this.createRequestOptions();
      this.$emit('save', params);
      this.close();
    }
  }
};